import { Bling } from "./modules/bling";
import coopToggle from "./modules/toggle";
import coopDropdown from "./modules/dropdown";
import { moveLeft, moveRight } from "./modules/benefitBar";
import { initAccordions } from "./modules/accordion";
import { initialiseAccordionSections } from "./modules/accordionSection";
import { initialiseArticleCarousel } from "./modules/articleCarousel";
import { initialiseGliders } from "./modules/initialiseGliders";
import { initIEStickybar } from "./modules/stickyBar";
import { viewMoreToggle } from "./modules/viewMore";
import { onCancelPlansSubmit } from "./modules/cancel-plan";
import { initStickyCta } from "./modules/stickyCta";
import "@coopdigital/funeralcare-components";

/**
 * Before all else we remove the no-js class from the body tag.
 */
Bling.$("body").classList.remove("no-js");

/**
 * Init for the Coop Toggle module.
 */
document.addEventListener("DOMContentLoaded", function () {
  if (Bling.$(".coop-c-toggle__trigger")) {
    coopToggle(Bling.$(".coop-c-toggle__trigger"));
  }

  if (Bling.$(".coop-c-dropdown__trigger")) {
    coopDropdown(Bling.$(".coop-c-dropdown__trigger"));
  }

  const leftBenefitButton = Bling.$("#coop-c-benefitbar__leftbutton");
  if (leftBenefitButton) {
    leftBenefitButton.addEventListener("click", moveLeft);
  }

  const rightBenefitButton = Bling.$("#coop-c-benefitbar__rightbutton");
  if (rightBenefitButton) {
    rightBenefitButton.addEventListener("click", moveRight);
  }

  const accordionOnPage = Bling.$(".coop-c-accordion");
  if (accordionOnPage) {
    initAccordions();
  }

  const cancelPlansButton = Bling.$(".coop-form__cancel-plan-btn");
  if (cancelPlansButton) {
    cancelPlansButton.addEventListener("click", onCancelPlansSubmit);
  }

  const stickyBar = Bling.$(".sticky");
  if (stickyBar) {
    initIEStickybar();
  }

  initStickyCta();

  const hasViewMoreToggle = Bling.$(".show-view-more-mobile");
  if (hasViewMoreToggle) {
    viewMoreToggle();
  }

  if (Bling.$(".comparison-grid")) {
    var mobileBreakpoint = 767;
    var cardClasses = [
      "comparison-grid__item-section--header",
      "comparison-grid__item-section--whats-included",
      "comparison-grid__item-section--whats-not-included",
      "comparison-grid__item-finalsection",
    ];

    if (window.innerWidth > mobileBreakpoint) {
      var numberOfCards = document.getElementsByClassName(
        "comparison-grid__item-section--header"
      ).length;

      for (var i = 0; i < numberOfCards - 1; i += 2) {
        for (var j = 0; j < cardClasses.length - 1; j++) {
          var firstSections = document.getElementsByClassName(cardClasses[j]);
          var leftFirstSection = firstSections[i];
          var leftFirstSectionHeight = leftFirstSection.offsetHeight;
          var rightFirstSection = firstSections[i + 1];
          var rightFirstSectionHeight = rightFirstSection.offsetHeight;
          leftFirstSectionHeight > rightFirstSectionHeight
            ? (rightFirstSection.style.height = leftFirstSectionHeight + "px")
            : (leftFirstSection.style.height = rightFirstSectionHeight + "px");
        }
      }
    }
  }
});

initialiseGliders();

if (document.querySelector(".video-block-container")) {
  const video_thumbnail_buttons = [
    ...document.querySelectorAll(".coop-c-video__frame-button"),
  ];

  const getCurrentVideo = () => {
    const url = document.querySelector("#primaryVideo").src;
    const title = document.querySelector("#primaryTitle").innerHTML;
    return { url, title };
  };

  video_thumbnail_buttons.forEach((video_thumbnail_button) =>
    video_thumbnail_button.addEventListener("click", function () {
      const data = {
        url: video_thumbnail_button.dataset.iframeUri,
        title: video_thumbnail_button.dataset.iframeTitle,
      };
      const currentVideo = getCurrentVideo();
      document.querySelector("#primaryVideo").src = data.url;
      document.querySelector("#primaryTitle").innerHTML = data.title;
      video_thumbnail_button.dataset.iframeUri = currentVideo.url;
      video_thumbnail_button.dataset.iframeTitle = currentVideo.title;
      video_thumbnail_button.nextElementSibling.src = currentVideo.url;
      video_thumbnail_button.parentElement.nextElementSibling.firstElementChild.innerHTML =
        currentVideo.title;
    })
  );
}

if (document.querySelector(".coop-fnc-accordion-section-container")) {
  initialiseAccordionSections();
}

window.addEventListener("load", () => {
  const trustpilotContainer = document.querySelector(
    ".coop-c-trustpilot-bar__container"
  );
  if (trustpilotContainer) {
    if (!trustpilotContainer.querySelector("iframe")) {
      trustpilotContainer.style = "display: none;";
    }
  }
});

initialiseArticleCarousel();
